type ThemeColours = {
    primary: string;
    primaryTone: string;
    secondary: string;
    secondaryTone: string;

    tertiary: string;

    monotoneMidLight: string;
    monotoneMid: string;
    monotoneMidDark: string;
    monotoneDark: string;

    alert: string;

    accentPrimary: string;
    accentSecondary: string;
    accent3?: string;
    accent4?: string;
    accent5?: string;
    accent6?: string;
    accent7?: string;
    accent8?: string;

    backgroundLightest: string;
    backgroundLighter: string;
    backgroundLight: string;
    backgroundLightTone: string;

    background: string;
    brilliant: string;
};

type ThemeBreakpoints = {
    xxs: number;
    xs: number;
    sm: number;
    md: number;
    lg: number;
    xl: number;
};

type ThemeSpacing = {
    length: number;
    increment: number;
    rem: number;
};

type ThemeIcons = {
    info: string;
    error: string;
    success: string;
    successCircle: string;
};

export type ThemeTemplate = {
    colors: ThemeColours;
    breakpoints: string[];
    radii: string[];
    fonts: { [key: string]: string };
    fontWeights: { [key: string]: string };
    space: string[];
    gridCols: number;
    fontSizes: string[];
    lineHeights: string[];
    zIndices: number[];
    icons: ThemeIcons;
};

export type ThemeProps = {
    theme?: ThemeTemplate;
};

// Note on space object:
// px val:      0,  4,    8,   12,   16,  20,   24,  28,   32, 36,   40,  44,   48,  52,    56,   60,    64,   68,    72,   76,   80,  84,    88,   92,    96
// rem val:     0,  0.25, 0.5, 0.75, 1,   1.25, 1.5, 1.75, 2,  2.25, 2.5, 2.75, 3,   3.25,  3.5,  3.75,  4,    4.25,  4.5,  4.75, 5,   5.25,  5.5,  5.75,  6
// pos:         0,  1,    2,   3,    4,   5,    6,   7,    8,  9,    10,  11,   12,  13,    14,   15,    16,   17,    18,   19,   20,  21,    22,   23,    24

 const createTheme = (
    colors: ThemeColours,
    icons: ThemeIcons,
    breakpoints: ThemeBreakpoints = { xxs: 0, xs: 374, sm: 567, md: 767, lg: 1023, xl: 1279 },
    spacing: ThemeSpacing = { length: 25, increment: 4, rem: 16 }
): ThemeTemplate => ({
    colors,
    breakpoints: Object.entries(breakpoints).map(([_, v]) => `${v}px`),
    radii: ["0rem", ".125rem", ".25rem"],
    fonts: {
        fontFamily: "'Open Sans', san-serif"
    },
    fontWeights: {
        light: "300",
        regular: "400",
        semiBold: "600",
        bold: "700"
    },
    space: new Array(spacing.length)
        .fill(null)
        .map((_, i) => (i * spacing.increment)/spacing.rem + "rem"),
    gridCols: 12,
    fontSizes: [
        "0.75rem",
        ".875rem",
        "1rem",
        "1.125rem",
        "1.25rem",
        "1.5rem",
        "1.75rem",
        "2rem",
        "3rem",
        "4rem",
        "6rem",
        "8rem"],
    lineHeights: [
        "0.75rem",
        ".875rem",
        "1rem",
        "1.125rem",
        "1.25rem",
        "1.5rem",
        "1.75rem",
        "2rem",
        "3rem",
        "4rem",
        "6rem",
        "8rem"
    ],
    zIndices: [-1, 0, 1, 2, 3, 4, 5],
    icons
});
export default createTheme;
